// API configuration for different environments
const getApiUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    // Production API URL (Render)
    return process.env.REACT_APP_API_URL || 'https://medhive-i0to.onrender.com';
  }
  // Development API URL (localhost)
  return 'http://localhost:5000';
};

export const API_BASE_URL = getApiUrl();

export const API_ENDPOINTS = {
  AUTH: `${API_BASE_URL}/api/auth`,
  RESIDENT: `${API_BASE_URL}/api/resident`,
  DIRECTOR: `${API_BASE_URL}/api/director`,
  ATTENDING: `${API_BASE_URL}/api/attending`,
  ADMINISTRATIVE: `${API_BASE_URL}/api/administrative`,
  MEDICAL_STUDENT: `${API_BASE_URL}/api/medical-student`,
  PROTECTED: `${API_BASE_URL}/api/protected`,
  DASHBOARD: `${API_BASE_URL}/api`,
  EVENTS: `${API_BASE_URL}/api/events`,
  EVENT_ATTACHMENTS: `${API_BASE_URL}/api/event-attachments`,
  EVENT_INVITATIONS: `${API_BASE_URL}/api/event-invitations`,
  SCHEDULES: `${API_BASE_URL}/api/schedules`,
  USERS: `${API_BASE_URL}/api/users`,
  PROMOTIONS: `${API_BASE_URL}/api/promotions`,
  GRADUATIONS: `${API_BASE_URL}/api/graduations`,
  ANNOUNCEMENTS: `${API_BASE_URL}/api/announcements`,
  INSTITUTIONAL_ADMIN: `${API_BASE_URL}/api/institutional-admin`,
  CONFERENCES: `${API_BASE_URL}/api/conferences`,
  CONFERENCE_SESSIONS: `${API_BASE_URL}/api/conference-sessions`,
  CONFERENCE_ATTENDANCE: `${API_BASE_URL}/api/conference-attendance`,
  UPLOADS: `${API_BASE_URL}/uploads`,
  // For profile pictures that already include /uploads/ in their path
  PROFILE_PICS: `${API_BASE_URL}`,
  CONFERENCE_SESSIONS_DELETE_EVENTS_FOR_YEAR: `${API_BASE_URL}/api/conference-sessions/academic-year`,
  CONTACT: `${API_BASE_URL}/api/contact`,
  CUSTOM_ROTATION_TYPES: `${API_BASE_URL}/api/custom-rotation-types`,
  CALENDAR_SUBSCRIPTIONS: `${API_BASE_URL}/api/calendar-subscriptions`,
  PROGRAMS: `${API_BASE_URL}/api/programs`,
  ONBOARDING: `${API_BASE_URL}/api/onboarding`,
  RESOURCES: `${API_BASE_URL}/api/resources`,
  DISCUSSIONS: `${API_BASE_URL}/api/discussions`,
  DELEGATIONS: `${API_BASE_URL}/api/delegations`,
  GUIDES: `${API_BASE_URL}/api/guides`,
  FLASHCARDS: `${API_BASE_URL}/api/flashcards`,
  FLOW_DIAGRAMS: `${API_BASE_URL}/api/flow-diagrams`,
}; 